import React, { useState } from 'react';
import './DealerSingle.css';

// Import necessary components
import { Car, Comments, Faqs, PageSidebar, PageTitle } from '../../../components';

// Import React Router hook to get dealer data from the previous page
import { useLocation } from 'react-router-dom';

// Import FontAwesome icon
import { FaCheck } from 'react-icons/fa';



const DealerInfo = () => {

  // State to manage the active tab (e.g., overview, details, etc.)
  const [activeTab, setActiveTab] = useState('overview');

  // Function to handle tab switching
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Get dealer data passed from the previous page
  const location = useLocation();  
  const dealerSingle = location.state; 

  // Function to handle form submission
  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    event.target.reset(); // Reset the form fields
  };

  return (
    <>

      {/* Page Title Section */}
      <PageTitle title={'Dealer Single'} page={'Dealer Single'} />

      <section className='dealer-single page-single'>

        <div className="dealer-info page-info">

          {/* Dealer Image */}
          <div className="image">
            <img src={dealerSingle.image} alt={dealerSingle.title} />
          </div>

          {/* Dealer Content */}
          <div className="content tab-info">
            
            {/* Dealer Info Tabs - Tab Buttons */}
            <div className="dealer-info-tabs tab-buttons">
              <button 
                type="button" 
                className={`button ${activeTab === 'overview' ? 'active' : ''}`} 
                onClick={() => handleTabClick('overview')}
              >
                Overview
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'inventory' ? 'active' : ''}`} 
                onClick={() => handleTabClick('inventory')}
              >
                Inventory
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'faqs' ? 'active' : ''}`} 
                onClick={() => handleTabClick('faqs')}
              >
                FAQs
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'map' ? 'active' : ''}`} 
                onClick={() => handleTabClick('map')}
              >
                Map
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'reviews' ? 'active' : ''}`} 
                onClick={() => handleTabClick('reviews')}
              >
                Reviews
              </button>
            </div>

            {/* Dealer Info Tabs - Tab Sections */}
            <div className="tab-sections">

              {/* Overview Tab Section */}
              {activeTab === 'overview' && (

                <div className="overview tab-section active" id="overview">
            
                  {/* Service heading */}
                  <h3 className='main-heading'>{dealerSingle.title}</h3>

                  {/* Service Content */}
                  {dealerSingle.overviews.map((overview, index) => (
                    <p key={index}>{overview}</p>
                  ))}

                  {/* Section for Services Offered */}
                  <div className='service-benefits sub-section'>
        
                    <h3 className='sub-heading'>Services Offered</h3>
        
                    <p>By choosing {dealerSingle.title}, you'll enjoy the following benefits:</p>
        
                    {/* List of Services Offered */}
                    <ul>
                      {dealerSingle.services.map((service, index) => {
                        return <li key={index}><FaCheck className='icon' />{service}</li>
                      })}
                    </ul>
        
                  </div>

                </div>
              )}

              {/* Inventory Tab Section */}
              {activeTab === 'inventory' && (
                <div className="cars tab-section" id="inventory">
                  <div className="car-container grid">
                    {/* Render each car component */}
                    {dealerSingle.inventory.map((car) => {
                      return(  
                        <Car key={car.id} car={car} /> 
                      )
                    }) 
                    }
                  </div>
                </div>
              )}

              {/* FAQs Tab Section */}
              {activeTab === 'faqs' && (
                <div className="tab-section" id="faqs">
                  {/* Faq Accordion container */}
                  <Faqs faqs={dealerSingle.faqs} />
                </div>
              )}

              {/* Map Tab Section */}
              {activeTab === 'map' && (
                <div className="map tab-section" id="map">
                  <p>Visit us at {dealerSingle.title} and explore our wide selection of vehicles. Our knowledgeable staff is here to guide you through every step of the car buying experience. Feel free to stop by for a personalized consultation, or take a test drive with your favorite car models. We look forward to helping you find your perfect vehicle!</p>
                  <iframe
                    src={dealerSingle.map}
                    allowFullScreen
                    loading="lazy"
                    title="Event Venue Map"
                  ></iframe>
                </div>
              )}

              {/* Reviews Tab Section */}
              {activeTab === 'reviews' && (
                <div className="reviews tab-section" id="reviews">

                  {/* Reviews */}
                  <Comments comments={dealerSingle.reviews} />

                  <div className='product-review'>
                    {/* Leave a Comment Form */}
                    <form className='form' onSubmit={handleSubmit}>

                      <h2>leave a comment</h2> {/* Comment Form Title */}

                      {/* Input Fields */}
                      <div className='input-box'>
                        <input type="text" name="name" className='box' id="name" placeholder="name" required /> {/* Name Input Field */}
                        <input type="email" name="email" className='box' id="email" placeholder="email" required /> {/* Email Input Field */}
                      </div>
                      
                      <textarea cols="30" rows="10" name="comment" className='box' id="comment" placeholder="comment"></textarea> {/* Comment Textarea */}
                      
                      <button type="submit" name="submit" id="submit" className='btn'>submit</button> {/* Submit Button */}

                    </form>

                  </div>

                </div>
              )}

            </div>
          </div>
        </div>

        {/* Sidebar Section */}
        <PageSidebar
          heading={'Dealer'}
          details={dealerSingle.details}
        />

      </section>

     </> 
  );
};

export default DealerInfo;